export const purchaseType = {
  buy: 1,
  cart: 2
};

export const packageType = {
  NONE: 0,
  DAY_BOOKING: 1,
  SLOT_BOOKING: 2,
  HOURLY_BOOKING: 3,
  ADMIN_PACKAGE: 4,
  CUSTOM_PACKAGE: 5,
  MONTHLY_PACKAGE: 6
};

export const packageCategoryTypes = {
  AdminPackage:'ADMIN',
  CustomPackage: 'CUSTOM'
};

export const profileSetupStatus = {
  signup: 1,
  profileSetup: 2
};
export const myBookingStatuses = {
  UPCOMING : 1,
  PAST: 2
};
